import 'tom-select/dist/css/tom-select.default.css';
export default {
  'symfony--ux-autocomplete--autocomplete': import(/* webpackMode: "eager" */ '@symfony/ux-autocomplete/dist/controller.js'),
};